import React from 'react';
import UserFeedback from '../components/UserFeedback';
import { changePassword, fetchUserProfile, resetPassword, } from '../utils/api/userAccountApi';
var MIN_PASSWORD_LENGTH = 12;
var validateNewPassword = function (newPassword, confirmPassword) {
    if (newPassword !== confirmPassword) {
        return 'Passordene er ikke like';
    }
    if (newPassword.length < MIN_PASSWORD_LENGTH) {
        return "Passordet m\u00E5 v\u00E6re minst " + MIN_PASSWORD_LENGTH + " tegn";
    }
    if (!/[A-ZÆØÅ]/.test(newPassword)
        || !/[a-zæøå]/.test(newPassword)
        || !/[0-9]/.test(newPassword)) {
        return 'Passordet må inneholde store og små bokstaver og minst ett tall';
    }
    return null;
};
var PasswordTips = function () { return React.createElement("section", { className: "note" },
    React.createElement("h2", null, "Passordtips"),
    React.createElement("p", null, "Vi anbefaler at du lager et passord som er langt, men samtidig enkelt \u00E5 huske, for eksempel en middels lang setning."),
    React.createElement("p", null, "Ikke bruk et passord du bruker andre steder.")); };
/** Changes the password with a one-time code from the "forgot password" email. */
var ResetPasswordPanel = function (_a) {
    var activationCode = _a.activationCode;
    var _b = React.useState(''), newPassword = _b[0], setNewPassword = _b[1];
    var _c = React.useState(''), confirmPassword = _c[0], setConfirmPassword = _c[1];
    var _d = React.useState(false), isSubmitting = _d[0], setIsSubmitting = _d[1];
    var _e = React.useState(false), isReset = _e[0], setIsReset = _e[1];
    var _f = React.useState(false), isInvalidCode = _f[0], setIsInvalidCode = _f[1];
    var _g = React.useState(null), error = _g[0], setError = _g[1];
    React.useEffect(function () {
        if (!isReset) {
            return function () { return undefined; };
        }
        var timeout = setTimeout(function () {
            window.location.href = '/logg_inn';
        }, 2500);
        return function () { return clearTimeout(timeout); };
    }, [isReset]);
    var handleSubmit = function (event) {
        event.preventDefault();
        var validationError = validateNewPassword(newPassword, confirmPassword);
        if (validationError) {
            setError(validationError);
            return;
        }
        setError(null);
        setIsSubmitting(true);
        resetPassword({ code: activationCode, newPassword: newPassword, confirmPassword: confirmPassword })
            .then(function () { return setIsReset(true); })
            .catch(function () { return setIsInvalidCode(true); })
            .finally(function () { return setIsSubmitting(false); });
    };
    if (isInvalidCode) {
        return React.createElement(React.Fragment, null,
            React.createElement("h1", null, "For gammel kobling"),
            React.createElement("em", null, "F\u00E5r ikke endret passord"),
            React.createElement("div", null,
                React.createElement("strong", null, "Koblingen du trykket p\u00E5 for \u00E5 komme hit er for gammel eller ugyldig."),
                React.createElement("p", null, "Koblingene som sendes fra ibok.no kan kun brukes i 24 timer etter de ble sendt ut. F\u00F8lg koblingen under for \u00E5 f\u00E5 tilsendt en ny kobling."),
                React.createElement("a", { href: "/glemt_passord", id: "forgot_password_link" }, "Glemt passord")));
    }
    if (isReset) {
        return React.createElement(UserFeedback, { status: "success" },
            React.createElement("p", null,
                React.createElement("strong", null, "Ditt passord har blitt endret!")),
            React.createElement("p", null, "Du sendes n\u00E5 til innloggingssiden, der du kan logge inn med det nye passordet ditt."),
            React.createElement("a", { href: "/logg_inn" }, "G\u00E5 til innlogging"));
    }
    return React.createElement(React.Fragment, null,
        React.createElement("h1", null, "Endre passord"),
        React.createElement("form", { id: "change_password_form", className: "vertical", onSubmit: handleSubmit },
            error && React.createElement("p", { role: "alert", className: "form-error" }, error),
            React.createElement("label", { htmlFor: "new_password" }, "Nytt passord"),
            React.createElement("input", { id: "new_password", type: "password", name: "new_password", title: "Passordet m\u00E5 inneholde minst ett nummer, ha store og sm\u00E5 bokstaver og v\u00E6re minst " + MIN_PASSWORD_LENGTH + " tegn", placeholder: "********", autoComplete: "new-password", required: true, value: newPassword, disabled: isSubmitting, onChange: function (event) { return setNewPassword(event.target.value); } }),
            React.createElement("label", { htmlFor: "confirm_password" }, "Gjenta passord"),
            React.createElement("input", { id: "confirm_password", type: "password", name: "confirm_password", placeholder: "********", autoComplete: "new-password", required: true, value: confirmPassword, disabled: isSubmitting, onChange: function (event) { return setConfirmPassword(event.target.value); } }),
            React.createElement("button", { type: "submit", disabled: isSubmitting }, isSubmitting ? 'Endrer passord...' : 'Endre passord')),
        React.createElement(PasswordTips, null));
};
/** Changes the password of the signed-in user. */
var ChangePasswordPanel = function () {
    var _a = React.useState(true), isCheckingAccount = _a[0], setIsCheckingAccount = _a[1];
    var _b = React.useState(''), currentPassword = _b[0], setCurrentPassword = _b[1];
    var _c = React.useState(''), newPassword = _c[0], setNewPassword = _c[1];
    var _d = React.useState(''), confirmPassword = _d[0], setConfirmPassword = _d[1];
    var _e = React.useState(false), isSubmitting = _e[0], setIsSubmitting = _e[1];
    var _f = React.useState(false), isChanged = _f[0], setIsChanged = _f[1];
    var _g = React.useState(null), error = _g[0], setError = _g[1];
    React.useEffect(function () {
        var isMounted = true;
        fetchUserProfile()
            .then(function (profile) {
            if (!isMounted) {
                return;
            }
            // OAuth users without a password change their
            // password through their OAuth provider instead
            if (profile.canChangePassword === false) {
                window.location.href = '/min_side';
                return;
            }
            setIsCheckingAccount(false);
        })
            .catch(function (err) {
            if (!isMounted) {
                return;
            }
            if (err && (err.status === 401 || err.status === 403)) {
                window.location.href = "/logg_inn?redirect=" + encodeURIComponent('/endre_passord');
                return;
            }
            setIsCheckingAccount(false);
        });
        return function () {
            isMounted = false;
        };
    }, []);
    React.useEffect(function () {
        if (!isChanged) {
            return function () { return undefined; };
        }
        var timeout = setTimeout(function () {
            window.location.href = '/innstillinger';
        }, 2500);
        return function () { return clearTimeout(timeout); };
    }, [isChanged]);
    var handleSubmit = function (event) {
        event.preventDefault();
        var validationError = validateNewPassword(newPassword, confirmPassword);
        if (validationError) {
            setError(validationError);
            return;
        }
        setError(null);
        setIsSubmitting(true);
        changePassword({ currentPassword: currentPassword, newPassword: newPassword, confirmPassword: confirmPassword })
            .then(function () { return setIsChanged(true); })
            .catch(function (err) {
            // The new password is validated client-side first,
            // so a rejection here is in practice the current password not matching
            if (err && err.status === 400) {
                setError('Feil passord!');
            }
            else {
                setError('Kunne ikke endre passordet ditt. Prøv igjen om litt.');
            }
            setIsSubmitting(false);
        });
    };
    if (isCheckingAccount) {
        return React.createElement("h1", null, "Endre passord");
    }
    if (isChanged) {
        return React.createElement(UserFeedback, { status: "success" },
            React.createElement("p", null,
                React.createElement("strong", null, "Ditt passord har blitt endret!")),
            React.createElement("p", null, "Du sendes n\u00E5 tilbake til innstillingene dine."),
            React.createElement("a", { href: "/innstillinger" }, "Til innstillinger"));
    }
    return React.createElement(React.Fragment, null,
        React.createElement("h1", null, "Endre passord"),
        React.createElement("form", { id: "change_password_form", className: "vertical", onSubmit: handleSubmit },
            error && React.createElement("p", { role: "alert", className: "form-error" }, error),
            React.createElement("label", { htmlFor: "old_password" }, "Gammelt passord"),
            React.createElement("input", { id: "old_password", type: "password", name: "old_password", placeholder: "********", autoComplete: "current-password", required: true, value: currentPassword, disabled: isSubmitting, onChange: function (event) { return setCurrentPassword(event.target.value); } }),
            React.createElement("label", { htmlFor: "new_password" }, "Nytt passord"),
            React.createElement("input", { id: "new_password", type: "password", name: "new_password", title: "Passordet m\u00E5 inneholde minst ett nummer, ha store og sm\u00E5 bokstaver og v\u00E6re minst " + MIN_PASSWORD_LENGTH + " tegn", placeholder: "********", autoComplete: "new-password", required: true, value: newPassword, disabled: isSubmitting, onChange: function (event) { return setNewPassword(event.target.value); } }),
            React.createElement("label", { htmlFor: "confirm_password" }, "Gjenta passord"),
            React.createElement("input", { id: "confirm_password", type: "password", name: "confirm_password", placeholder: "********", autoComplete: "new-password", required: true, value: confirmPassword, disabled: isSubmitting, onChange: function (event) { return setConfirmPassword(event.target.value); } }),
            React.createElement("button", { type: "submit", disabled: isSubmitting }, isSubmitting ? 'Endrer passord...' : 'Endre passord')),
        React.createElement(PasswordTips, null));
};
/**
 * "Endre passord" — either changes the password of the
 * signed-in user, or sets a new password with a one-time
 * code from the password reset email.
 * */
var ChangePasswordPage = function (_a) {
    var activationCode = _a.activationCode;
    if (activationCode) {
        return React.createElement("div", { className: "main-content" },
            React.createElement(ResetPasswordPanel, { activationCode: activationCode }));
    }
    return React.createElement("div", { className: "main-content" },
        React.createElement(ChangePasswordPanel, null));
};
export default ChangePasswordPage;
